import type { ThinkingLevel } from "@elyracode/agent-core";
import { Container, type SelectItem, SelectList, type SelectListLayoutOptions } from "@elyracode/tui";
import { getSelectListTheme } from "../theme/theme.js";
import { DynamicBorder } from "./dynamic-border.js";

const THINKING_SELECT_LIST_LAYOUT: SelectListLayoutOptions = {
	minPrimaryColumnWidth: 10,
	maxPrimaryColumnWidth: 16,
};

const LEVEL_DESCRIPTIONS: Record<ThinkingLevel, string> = {
	off: "no extended thinking",
	minimal: "brief reasoning, fastest",
	low: "light reasoning",
	medium: "balanced reasoning",
	high: "thorough reasoning",
	xhigh: "maximum reasoning, slowest",
};

/**
 * Selector for the thinking level of the current model. Only the levels the
 * model actually supports are offered; the session clamps on selection.
 */
export class ThinkingSelectorComponent extends Container {
	private selectList: SelectList;

	constructor(
		levels: ThinkingLevel[],
		currentLevel: ThinkingLevel,
		onSelect: (level: ThinkingLevel) => void,
		onCancel: () => void,
	) {
		super();

		const items: SelectItem[] = levels.map((level) => ({
			value: level,
			label: level,
			description: level === currentLevel ? `${LEVEL_DESCRIPTIONS[level]} (current)` : LEVEL_DESCRIPTIONS[level],
		}));

		this.addChild(new DynamicBorder());

		this.selectList = new SelectList(items, 10, getSelectListTheme(), THINKING_SELECT_LIST_LAYOUT);

		const currentIndex = levels.indexOf(currentLevel);
		if (currentIndex !== -1) {
			this.selectList.setSelectedIndex(currentIndex);
		}

		this.selectList.onSelect = (item) => {
			onSelect(item.value as ThinkingLevel);
		};
		this.selectList.onCancel = () => {
			onCancel();
		};

		this.addChild(this.selectList);
		this.addChild(new DynamicBorder());
	}

	getSelectList(): SelectList {
		return this.selectList;
	}
}
